import MessagesContainer from './MessagesContainer';

export default MessagesContainer;